import { render } from "./bottom_navigation.vue?vue&type=template&id=38460ce6"
import script from "./bottom_navigation.vue?vue&type=script&lang=js"
export * from "./bottom_navigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__